import { render, staticRenderFns } from "./featureSix.vue?vue&type=template&id=1ec2cde8&"
import script from "./featureSix.vue?vue&type=script&lang=js&"
export * from "./featureSix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports